import { calendarConstants } from './constants';

export const saveCalendarSelection = (filterBy, range = '') => ({
  type: calendarConstants.SAVE,
  filterBy,
  range
});
